import store from '@/store';
import auth from '@/common/auth/auth';

export default {
    store,
    version: 6,
    defaultColumns: [
        {
            name: 'redemptionCode',
            type: 'link',
            to: ({fields}) => ({
                name: 'coupon-details',
                params: {
                    id: fields.redemptionCode,
                },
            }),
            predicate: auth.$pages['update-coupon'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
            sortable: true,
            style: {truncate: true},
            sticky: true,
        },
        {
            name: 'description',
        },
        {
            header: 'Type',
            name: 'discount.type',
            sortable: true,
        },
        {
            header: 'Valid from',
            name: 'issuedTime',
            type: 'datetime',
            sortable: true,
        },
        {
            header: 'Valid until',
            name: 'expiredTime',
            type: 'datetime',
            sortable: true,
        },
        {
            name: 'redeemedTime',
            type: 'datetime',
            sortable: true,
        },
    ],
    otherColumns: [
        {
            name: 'status',
            type: 'badge',
            map: {
                issued: 'badge-positive',
                expired: 'badge-negative',
            },
            sortable: true,
        },
        {
            name: 'createdTime',
            header: 'Creation Time',
            type: 'datetime',
            sortable: true,
        },
        {
            name: 'updatedTime',
            header: 'Last Update Time',
            type: 'datetime',
            sortable: true,
        },
        {
            name: 'canceledTime',
            type: 'datetime',
            sortable: true,
        },
    ],
};
